import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.vip20.bonuses.birthday_bonus,
    props.vip20.level_preset,
    props.vip20.buttons.birthday_bonus,
    (bonus, level_preset, button) => {
        return {
            bonus,
            level_preset,
            button
        }
    }
)